<template lang="pug">
  validation-observer.layout(v-slot="{ invalid, validated, errors }" tag="form" @submit.prevent="save()")
    //- 404 Error
    template(v-if="value.$error && value.$error.code == 404")
      page-not-found
        p Запись которую вы пытаетесь отредактировать не существует или была удалена

    template(v-else)
      //- Form
      layout
        template(v-slot:toolbar)
          b-navbar
            template(v-slot:start)

              //- Кнопка назад (back-link=true)
              .navbar-item(v-if="backLink")
                button.button(@click="$router.go(-1)" type="button")
                  b-icon(icon="arrow-left-bold")
                  span Назад

              //- Данные о записи (статус, id, дата создания и обноваления)
              .navbar-item(v-if="value.id")
                .tags
                  b-tag(v-if="value.statusName" :type="value.status ? 'is-success' : 'is-danger'") {{ value.statusName }}
                  b-tag.is-grey(v-if="value.id") # <b>{{ value.id }}</b>
                  b-tag.is-grey(v-if="value.created_at") Создан: <b>{{ value.created_at | datetime }}</b>
                  b-tag.is-grey(v-if="value.updated_at") Обновлен: <b>{{ value.updated_at | datetime }}</b>

            //- Actions: Кнопки формы
            template(v-slot:end)
              .navbar-item
                .buttons
                  //- Сброс
                  .button(@click="reset" type="button" :disabled="!value.$isChanged") Сброс

                  //- Сохранить
                  button.button(
                    type="submit"
                    :class="{'is-loading':value.$state.saving, 'is-primary':value.$isChanged && !invalid}"
                    :disabled="!value.$isChanged || invalid"
                  )
                    b-icon(icon="check")
                    span Сохранить

        template(v-slot:content)
          //- Loader
          b-loading(:active="value.$state.loading")

          section.section(v-if="!value.$state.loading")

            //- Сообщение об ошибке
            b-message(v-if="value.$error" type="is-danger") {{ value.$error.message }}

              //- HTML Форма
            component(:is="formComponent" :value="value" :errors="apiErrors")

</template>

<script>
import formComponents from '@/forms';

export default {
  name: 'layout-form',

  components: {
    ...formComponents,
  },

  props: {
    value: Object,
    form: String,
    header: String,
    backLink: Boolean,
  },

  computed: {
    formComponent() {
      return `form-${this.form}`;
    },

    apiErrors() {
      let apiErrors = {};
      let error = this.value.$error;
      if (error && error.validation) {
        Object.keys(error.validation).forEach(field => {
          apiErrors[field] = error.validation[field][0];
        });
      }
      return apiErrors;
    },
  },

  methods: {
    save() {
      const promise = this.value.$save();
      promise
        .then(() => {
          this.$emit('afterSave', this.value);
        })
        .catch(error => {
          this.$emit('onError', error);
        });
    },

    reset() {
      this.value.$reset();

      this.$emit('afterReset');
    },
  },
};
</script>
